import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FeedbackSurveysIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "FeedbackSurveys",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M8.41 31.98H1.84c-.63 0-1.14-.51-1.14-1.14v-6.56c0-.63.51-1.14 1.14-1.14H8.4c.63 0 1.14.51 1.14 1.14v6.56c0 .63-.51 1.14-1.14 1.14ZM2.99 29.7h4.28v-4.28H2.99zM8.45 19.72H1.89c-.63 0-1.14-.51-1.14-1.14v-6.56c0-.63.51-1.14 1.14-1.14h6.56c.63 0 1.14.51 1.14 1.14v6.56c0 .63-.51 1.14-1.14 1.14m-5.42-2.29h4.28v-4.28H3.03zM22.31 25.32c-5.29 0-9.6-4.31-9.6-9.6s4.31-9.6 9.6-9.6 9.6 4.31 9.6 9.6-4.31 9.6-9.6 9.6m0-16.91c-4.03 0-7.31 3.28-7.31 7.31s3.28 7.31 7.31 7.31 7.31-3.28 7.31-7.31-3.28-7.31-7.31-7.31"
    }), /*#__PURE__*/_jsx("path", {
      d: "M22.31 21.42c-2.17 0-4.1-1.3-4.91-3.31-.24-.58.04-1.25.63-1.49.58-.24 1.25.04 1.49.63.46 1.15 1.56 1.89 2.79 1.89s2.33-.74 2.79-1.89c.24-.58.91-.86 1.49-.63.58.24.87.9.63 1.49a5.29 5.29 0 0 1-4.91 3.31"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "24.91",
      cy: "13.77",
      r: ".65"
    }), /*#__PURE__*/_jsx("path", {
      d: "M24.91 15.57c-.99 0-1.79-.8-1.79-1.79s.8-1.79 1.79-1.79 1.79.8 1.79 1.79-.8 1.79-1.79 1.79m0-2.29a.49.49 0 1 0 .002.982.49.49 0 0 0-.002-.982"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "19.71",
      cy: "13.77",
      r: ".65"
    }), /*#__PURE__*/_jsx("path", {
      d: "M19.71 15.57c-.99 0-1.79-.8-1.79-1.79s.8-1.79 1.79-1.79 1.79.8 1.79 1.79-.8 1.79-1.79 1.79m0-2.29a.49.49 0 1 0 .002.982.49.49 0 0 0-.002-.982M3.88 7.45c-.3 0-.59-.12-.81-.33L.45 4.49C0 4.05 0 3.32.45 2.88a1.14 1.14 0 0 1 1.62 0L3.89 4.7 8.32.25a1.15 1.15 0 0 1 1.62 0c.45.45.45 1.17 0 1.62L4.69 7.12c-.21.21-.51.33-.81.33"
    })]
  }));
};
FeedbackSurveysIcon.displayName = 'FeedbackSurveysIcon';